import React__default from 'react';
import styles from './MovErrorBox.module.scss.js';
import { CartMovError } from './CartMovError.js';
import { AutoshipLogo } from '../autoship-logo/AutoshipLogo.js';
import { TitleWithEdit } from '../../preview/title-with-edit/TitleWithEdit.js';

const MovErrorBox = (props) => {
    return (React__default.createElement("div", { className: styles.box },
        props.fromPreview ? (React__default.createElement(TitleWithEdit, { logoSize: 'small' })) : (React__default.createElement(AutoshipLogo, { className: styles.inlineLogo, logoSize: 'small' })),
        React__default.createElement(CartMovError, { size: 'small', mov: props.mov, moneyLeft: props.moneyLeft, currency: props.currency })));
};

export { MovErrorBox };
//# sourceMappingURL=MovErrorBox.js.map
